import styled from 'styled-components';

import { Picture } from 'components/picture';

export const EmptyState = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  padding: 0 2rem;
`;

export const EmptyStateImage = styled(Picture)`
  height: 8rem;
  width: 10rem;
  margin: 2rem auto;
`;

export const EmptyStateTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin-block-end: 0.3rem;
`;

export const EmptyStateDescription = styled.div`
  font-weight: 300;
  font-size: 0.95rem;
  margin-block-end: 1rem;
`;
